// {
//     "server_domain_name": "qa.biodigital.com",
//     "google_api_key": "66261904577-061oin26uo7sor0vrqc8dnn105irq82n.apps.googleusercontent.com",
//     "facebook_api_key": "218801781466301",
//     "server_hosted_app_smiletrain": "smiletrain-qa.biodigital.com",
//     "allow_auth_bypass": true,
//     "server_api_domain_name": "api-qa.biodigital.com",
//     "server_admin_domain_name": "admin-qa.biodigital.com",
//     "server_marketing_domain_name": "site-qa.biodigital.com",
//     "server_hosted_app_craniofacial": "civapro-qa.biodigital.com",
//     "server_developer_domain_name": "developer-qa.biodigital.com",
//     "server_accounts_domain_name": "accounts-qa.biodigital.com",
//     "server_hosted_app_craniofacial_patient": "civa-qa.biodigital.com",
//     "human_contact_email": "support@biodigital.com",
//     "developer_contact_email": "developers@biodigital.com"
// }

export class EnvironmentSettingsModel {
  google: string;
  facebook: string;

  static fromJSON(json: any): EnvironmentSettingsModel {
    const settings = new EnvironmentSettingsModel();
    settings.google = json.google_api_key;
    settings.facebook = json.facebook_api_key;

    return settings;
  }
}
